module.exports = __webpack_public_path__ + "static/img/duigou.1165070c.png";